<template>
<div>
	<div v-for="(item) in Items">
		<FilterBucketItem :Item="item" :SelectedFilterOptions="SelectedFilterOptions" @changeBucket="changeBucket" />
	</div>
</div>
</template>



<script>
import FilterBucketItem from './FilterBucketItem.vue';

export default {
	name: 'FilterBucket',
	components: { FilterBucketItem }, 
	props: {
		Items: Array,
		SelectedFilterOptions: String
	},
	methods: {
		changeBucket(r) {
		  this.$emit('changeBucket', r);
		}
	}
}
</script>
